<template>
  <v-card>
    <v-card-title>
      <h2 class="ff-darkblue">Passwort ändern</h2>
    </v-card-title>
    <v-card-text>
      <v-form>
        <span v-if="capslock" class="red--text">ACHTUNG: FESTSTELLTASTE AKTIV!</span>
        <v-text-field label="Altes Passwort" v-model="password1" ref="password1Textfield" @keyup.enter.native="onEnter"
                      min="8" :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (e1 = !e1)"
                      :type="e1 ? 'password' : 'text'" counter
                      :rules="pw1Rules"></v-text-field>
        <v-text-field label="Neues Passwort" hint="Wählen Sie ein Passwort mit mindestens 8 Zeichen" v-model="password2"
                      ref="password2Textfield" @keyup.enter.native="onEnter"
                      min="8" :append-icon="e2 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (e2 = !e2)"
                      :type="e2 ? 'password' : 'text'" counter
                      :rules="pw2Rules"></v-text-field>
        <v-text-field placeholder="Passwort nochmal eingeben" v-model="password3" ref="password3Textfield"
                      @keyup.enter.native="onEnter"
                      min="8" :append-icon="e3 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (e3 = !e3)"
                      :type="e3 ? 'password' : 'text'"
                      :rules="pw3Rules"></v-text-field>
        <v-alert :type="alertType" v-model="alertVisible" dismissible>
          {{ alertMessage }}
        </v-alert>
        <v-progress-linear :indeterminate="true" v-if="trying" height="2" color="primary"></v-progress-linear>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="silver" text @click.stop="fire_close">Abbrechen</v-btn>
      <v-btn color="primary" dark @click.stop="trySave">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  name: "change-password",
  data() {
    return {
      e1: true,
      e2: true,
      e3: true,
      password1: null,
      password2: null,
      password3: null,
      pw1Rules: [this.pw1Rule],
      pw2Rules: [this.pw2Rule],
      pw3Rules: [this.pw3Rule],
      alertVisible: false,
      alertMessage: null,
      alertType: "error",
      changeSuccessful: false,
      trying: false,
      capslock: false,
    }
  },
  mounted() {
    document.addEventListener('keydown', (event) => {
      this.capslock = event.getModifierState && event.getModifierState('CapsLock');
      //console.log( this.caps ); // true when you press the keyboard CapsLock key
    });
  },
  methods: {
    onEnter(ev) {
      //console.log(ev)
      var t = ev.target;
      var r = this.$refs;
      if (t === r.password1Textfield.$refs.input) r.password2Textfield.focus()
      else if (t === r.password2Textfield.$refs.input) r.password3Textfield.focus()
      else if (t === r.password3Textfield.$refs.input) {
        // r.agbCheckbox.focus();
      }
    },
    pw1Rule(v) {
      if (!v)
        return 'Geben Sie das bestehende Passwort ein'
      return true;
    },
    pw2Rule(v) {
      if (!v)
        return 'Passwort muss aus mindestens 8 Zeichen bestehen'
      if (v.length < 8)
        return 'Passwort muss aus mindestens 8 Zeichen bestehen'
      return true;
    },
    pw3Rule(v) {
      var pw1 = this.$refs.password2Textfield.value;
      // console.log("pw1: " + pw1 + " pw2: " + v );
      return !!(v == pw1) || 'Passwörter stimmen nicht überein'
      return true;
    },
    fire_close() {
      this.$emit("close");
    },
    async trySave() {
      if (this.changeSuccessful) {
        this.fire_close();
        return;
      }
      // save to db
      if (!this.password1 || !this.password2 || !this.password3) {
        this.alertType = "error";
        this.alertMessage = "Bitte füllen Sie alle Felder aus!";
        this.alertVisible = true;
        return;
      } else if (this.password2.length < 8 || this.password3 != this.password2) {
        this.alertType = "error";
        this.alertMessage = "Das neue Passwort genügt nicht den Anforderungen!";
        this.alertVisible = true;
        return;
      } else
        this.alertVisible = false;
      this.trying = true;
      await this.$backend.change_password(this.password1, this.password2);
      // fetch("/api/change_password?"+query({token:this.$store.state.token, old_pw: this.password1,new_pw: this.password2}))
      //     .then(function(response) {
      //       if(response.ok) {
      //         return response.json();
      //       }
      //       throw new Error('Password change failed due to server error!\n' + response.body);
      //     })
      //     .then(data => {
      //       if (data.invalid_session) {
      //         this.$store.commit("logout")
      //         this.$router.go(-1000);
      //         this.$router.replace("login");
      //         return;
      //       }
      //       if (data.success) {
      //         console.log("Password change successful:", data)
      //         // this.changeSuccessful=true;
      //         // this.alertType = "ok";
      //         // this.alertMessage = "Passwort wurde geändert! ";
      //         // this.alertVisible = true;
      //         // setTimeout(() => this.fire_close(), 1000);
      //         this.fire_close();
      //         this.$events.$emit("notify", "Passwort wurde geändert.")
      //       }
      //       else {
      //         console.log("pw change failed. reason: " + data.reason)
      //         this.alertType="info";
      //         this.alertMessage = "Passwort-Änderung fehlgeschlagen! "+data.reason;
      //         this.alertVisible = true;
      //       }
      //       this.trying=false;
      //     })
      //     .catch(error => {
      //       console.error(error);
      //       this.alertType="warning";
      //       this.alertMessage = "Der Backend-Server ist nicht erreichbar! Bitte kontaktieren Sie den Support.";
      //       this.alertVisible = true;
      //       this.trying=false;
      //     })
    },
  },

}
</script>

<style scoped>

</style>
